module.exports = __webpack_public_path__ + "img/4.75134755.png";